import {pageService} from '../../helpers/pageService';

export const state = {
    getAllPage : [],
    loading: false,
    pageCount: "",
    pagination : {},
    page: {
        page_name: "",
        page_title: "",
        page_content: ""
    },
};
export const mutations = {

    getPageListRequest(state) {
        state.loading = true;
    },
    getAllPage(state, payload) {
        state.getAllPage = payload.result.data;
        state.loading = false;
        state.pagination = payload.result;
        state.pageCount = payload.result.total;
    },
    getPageListFailure(state) {
        state.loading = false;
    },
    getPage(state, payload) {
        state.user = payload.result;
    },
};

export const actions = {

    async getPages({dispatch, commit}, data) {
        let token = JSON.parse(localStorage.getItem('token'));
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        commit("getPageListRequest");
        await pageService.getContentPage(data)
        .then(
            response => {
                commit('getAllPage', response.data);
            },
            error => {
                commit("getPageListFailure", error,{root:true});
                dispatch("alert/error", error, {root: true});
            }
        );
    },

    async addPage({dispatch,commit}, data) {
        return new Promise((resolve) => {
            let token = JSON.parse(localStorage.getItem('token'));
            window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            pageService.addContentPage(data)
            .then(
                response => {
                    dispatch('getAllPage');
                    resolve(response);
                },
                error => {
                    commit("error",error);
                }
            );
        });
    },

    async deletePage({dispatch,commit}, data) {
        return new Promise((resolve) => {
            let token = JSON.parse(localStorage.getItem('token'));
            window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            pageService.deleteContentPage(data)
            .then(
                response => {
                    dispatch('getAllPage');
                    resolve(response);
                },
                error => {
                    commit("error",error);
                }
            );
        });
    },

    async getContentPageById({dispatch, commit}, data) {
        let token = JSON.parse(localStorage.getItem('token'));
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return new Promise((resolve) => {
            pageService.getContentPageById(data)
            .then(
                response => {
                    commit('getPage', response.data);
                    resolve(response);
                },
                error => {
                    dispatch("alert/error", error, {root: true});
                }
            );
        })
    },

    async editContentPage({dispatch,commit}, data) {
        return new Promise((resolve) => {
            let token = JSON.parse(localStorage.getItem('token'));
            window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            pageService.editContentPage(data)
            .then(
                response => {
                    dispatch('getAllPage');
                    resolve(response);
                },
                error => {
                    commit("error",error);
                }
            );
        });
    },
};

export const getters = {
    getAllPage: state => state.getAllPage,
    loading: state => state.loading,
    pageCount: state => state.pageCount,
    pagination: state => state.pagination,
    pageData: state => state.getPage
};